import './log'
import Vue from 'vue';
import './cube-ui';
import App from './App.vue';
import router from './router';
import store from './store/index';
import 'amfe-flexible';
import './plugs/vant';
import vconsole from 'vconsole';
import {getEnv, sessionTokenNew} from '@/utils';
if (getEnv() !== 'prod') {
  new vconsole();
}
import {getQueryString,isIos} from '@/utils'
// if (getEnv() !== 'prod') {
//   new vconsole();
// }
import {
  Popup,
  Button,
  NavBar,
  Icon,
  Tab,
  Tabs,
} from 'vant'
import VueClipBoard from 'vue-clipboard2'
Vue.use(VueClipBoard)
Vue.use(Popup);
Vue.use(Button);
Vue.use(NavBar);
Vue.use(Icon);
Vue.use(Tab);
Vue.use(Tabs);

Vue.config.productionTip = false;
const type = getQueryString('type') || '';
const ad =  getQueryString('ad') || '';
const tp =  getQueryString('tp') || '';
const encryptData   =  getQueryString('encryptData') || '';
router.afterEach(route => {
  if (route.meta.title) {
    if(type =='XYF01' || type == 'XYF02'){
      document.title = '低息借款';
    }else{
      document.title = route.meta.title;
    }
    
    if (navigator.userAgent.includes('iPhone')) {
      // setTitle(document.title);
      const _iframe = document.createElement('iframe');
      _iframe.style.display = 'none';
      document.body.appendChild(_iframe);
      setTimeout(() => {
        document.body.removeChild(_iframe);
      }, 300);
      // if (navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
      //   const _iframe= document.createElement("iframe");
      //   _iframe.style.display = "none";
      //   document.body.appendChild(_iframe);
      //   setTimeout(() => {
      //     document.body.removeChild(_iframe);
      //   }, 300);
      // }
    }
  }
})
// 0923已下线
// store.dispatch('land/fetchDeviceReportHost') // 调用是否额外上报ipv6

store.dispatch('lowcode/getLowCodeConfig', {
  code: 'xyf_m_v4_001'
})
router.beforeEach(async (to, form, next) => {
  // 0923 下线切流灰度
  if(encryptData && !to.path.includes('down') && !(tp && ad === 'news_feed')){
    // try {
      const value =  type === 'SERVICE' ? 3 : 2;
      let res =  await store.dispatch('land/fetchGetWeiXinStatus',value)
      if(res.suc && res.bindStatus){
        if(type === 'XYF05' || type === 'bindWeiChat'){
          store.dispatch('land/report',1005183)
          // return
          // return;
          if(isIos()){
            if(type === 'bindWeiChat'){
              next('/down?style=14');
            }else{
              next('/down?style=13');
            }
          }else{
            xiJingJump();
          }
          next(false)
        }else if(type === 'SERVICE' && res.csUrl){
          store.dispatch('land/report',1005183)
          window.location.href = res.csUrl;
        
          // let resInfo =  await store.dispatch('land/getCsToken',res.userNo)
          // if(resInfo.status == 1 && resInfo.response.cs_url){
          //   store.dispatch('land/report',1005183)
          //   window.location.href = resInfo.response.cs_url
          // }else{
          //   next()
          // }
        } else{
          next()
        }
      }else{
        next()
      }
    // } catch (error) {
    //   console.log('error')
    //   next()
    // }
  } else if(tp && ad === 'news_feed'){
    await store.dispatch('app/fetchGetUrl',{ tp })
    next();
  }else{
    next();
  }
});
function xiJingJump(){
  if (window.AmsAppApi && typeof AmsAppApi.invokeLandingPage === 'function') {
    let androidAppUrl = 'https://h5.gdt.qq.com/xjviewer/nemo/3586120?nochace=1';
    if(type === 'bindWeiChat'){
      androidAppUrl = 'https://h5.gdt.qq.com/xjviewer/nemo/25188388?nochace=1'
    }
    let iosAppUrl = 'https://h5.gdt.qq.com/xjviewer/nemo/3586524?nochace=1';
    const gdt_vid = getQueryString('gdt_vid');
    const qz_gdt = getQueryString('qz_gdt');
    if (gdt_vid) {
      androidAppUrl = androidAppUrl + `&gdt_vid=${gdt_vid}`
      iosAppUrl = iosAppUrl + `&gdt_vid=${gdt_vid}`
    }
    if (qz_gdt) {
      androidAppUrl = androidAppUrl + `&qz_gdt=${qz_gdt}`
      iosAppUrl = iosAppUrl + `&qz_gdt=${qz_gdt}`
    }
    AmsAppApi.invokeLandingPage({
      androidAppUrl: androidAppUrl,
      iosAppUrl: iosAppUrl,
      autodownload: true,        // 开启自动下载
      callback: function (res) {
        // alert(res);
      }
    });
  }
}
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');

// arms 人群标签添加
try {
  let token = sessionTokenNew();
  if (window.__bl) {
    window.__bl.setConfig(
      {
        uid: token,
        c1: type
      }
    )
    window.__bl?.setPage(type, false)
  }

} catch (e) {

}
